"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

const inputCls =
  "w-full rounded-lg bg-panel2 px-3 py-2.5 text-sm text-ink ring-1 ring-inset ring-line transition-all outline-none " +
  "placeholder:text-faint hover:ring-line2 focus:bg-panel2 focus:ring-2 focus:ring-accent/60";

export function LoginForm() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email, password, totp }),
      });
      const data = (await res.json()) as { ok: boolean; error?: string };
      if (data.ok) {
        router.replace("/");
        router.refresh();
      } else {
        setError(data.error ?? "nie udało się zalogować");
      }
    } catch {
      setError("błąd sieci");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <label htmlFor="email" className="mb-1.5 block text-xs font-medium text-dim">Email</label>
        <input id="email" type="email" autoComplete="username" required value={email}
          onChange={(e) => setEmail(e.target.value)} className={inputCls} />
      </div>
      <div>
        <label htmlFor="password" className="mb-1.5 block text-xs font-medium text-dim">Hasło</label>
        <input id="password" type="password" autoComplete="current-password" required value={password}
          onChange={(e) => setPassword(e.target.value)} className={inputCls} />
      </div>
      <div>
        <label htmlFor="totp" className="mb-1.5 block text-xs font-medium text-dim">Kod z aplikacji (2FA)</label>
        <input id="totp" autoComplete="one-time-code" placeholder="123456 lub kod zapasowy"
          value={totp} onChange={(e) => setTotp(e.target.value)} className={`${inputCls} font-mono text-base tracking-[0.15em]`} />
      </div>
      {error && (
        <p role="alert" className="rounded-lg bg-bad/10 px-3 py-2 text-sm text-bad ring-1 ring-inset ring-bad/25">
          {error}
        </p>
      )}
      <button type="submit" disabled={busy}
        className="w-full rounded-lg bg-accent px-3 py-2.5 text-sm font-semibold text-bg shadow-e2 transition-all hover:brightness-110 active:scale-[0.99] disabled:opacity-50 disabled:hover:brightness-100">
        {busy ? "Logowanie…" : "Zaloguj"}
      </button>
    </form>
  );
}
